//Iconos
import { IoMdAdd } from "react-icons/io"

// DT1 (refactor por tamaño): filtros y tabla extraídos a subcomponentes presentacionales.
import { UsuariosFiltros } from "../components/UsuariosFiltros";
import { UsuariosTabla } from "../components/UsuariosTabla";
// Estado, React Query, acciones y carga inicial viven en el hook del caso de uso.
import { useUsuarios } from "../hooks/usuarios/useUsuarios";

export const Usuarios = () => {

  const {
    register,
    watch,
    handleSubmit,
    onSubmitBuscar,
    listaCompanias,
    listaSucursales,
    listaSedes,
    obtenerSucursalesPorCompania,
    obtenerSedesPorSucursal,
    mostrarOpcionTodos,
    isMobile,
    isLoadingFiltros,
    mostrarBotonAgregar,
    usuarioAgregar,
    isLoading,
    listaUsuarios,
    sucursalesTabla,
    buscar,
    mostrarBotonUsuarioGrupo,
    mostrarBotonUsuarioResetearContraseña,
    mostrarBotonEditar,
    mostrarBotonEliminar,
    usuarioGrupo,
    resetPassword,
    usuarioEditar,
    usuarioEliminar,
  } = useUsuarios()

  return (
    <>
      <div className="p-3">
        <div className="container-fluid" >
          <h3 className="tw-text-center tw-text-2xl tw-font-semibold tw-text-menu-primario tw-mt-1 tw-mb-4">Usuarios</h3>

          {/* Formulario */}
          <div className="tw-mb-4 tw-rounded-2xl tw-bg-white tw-p-4 tw-shadow-md tw-border tw-border-gray-100">
            <form onSubmit={handleSubmit(onSubmitBuscar)} className="row g-2">

              <UsuariosFiltros
                register={register}
                watch={watch}
                listaCompanias={listaCompanias}
                listaSucursales={listaSucursales}
                listaSedes={listaSedes}
                obtenerSucursalesPorCompania={obtenerSucursalesPorCompania}
                obtenerSedesPorSucursal={obtenerSedesPorSucursal}
                handleSubmit={handleSubmit}
                onSubmitBuscar={onSubmitBuscar}
                isMobile={isMobile}
                isLoadingFiltros={isLoadingFiltros}
                mostrarOpcionTodos={mostrarOpcionTodos}
              />
            </form>
          </div >
          {/* Fin formulario */}

          {
            mostrarBotonAgregar && (
              <div className="tw-mb-3">
                <button className='btn btn-primario btn-sm tw-inline-flex tw-items-center tw-gap-1 tw-rounded-lg tw-shadow-sm hover:tw-shadow-md tw-transition-shadow' onClick={usuarioAgregar}>
                  <IoMdAdd size={18} />
                  <span>Agregar</span>
                </button>
              </div>
            )
          }


          {/* Tabla de resultados */}

          <UsuariosTabla
            isLoading={isLoading}
            listaUsuarios={listaUsuarios}
            listaSucursales={sucursalesTabla}
            buscar={buscar}
            watch={watch}
            mostrarBotonUsuarioGrupo={mostrarBotonUsuarioGrupo}
            mostrarBotonUsuarioResetearContraseña={mostrarBotonUsuarioResetearContraseña}
            mostrarBotonEditar={mostrarBotonEditar}
            mostrarBotonEliminar={mostrarBotonEliminar}
            usuarioGrupo={usuarioGrupo}
            resetPassword={resetPassword}
            usuarioEditar={usuarioEditar}
            usuarioEliminar={usuarioEliminar}
          />


          {/* Fin Tabla de resultados */}
        </div>

      </div>

    </>
  )
};

